import React from "react";
import { useTranslation } from "next-i18next";
import type { ReactNode } from "react";

import { Heading } from "common/ui/Heading";

import styles from "./SelectHeader.module.scss";

interface Props {
  headers:  React.ReactNode[],
  selected: (string | number)[],
  children: ReactNode,
}

export function SelectHeader({ headers, selected, children }: Props) {
  const { t } = useTranslation("common");
  return (
    <tr className={styles.SelectHeader}>
      <th data-testid="header-checkbox">{children}</th>
      {selected.length > 0 ? (
        <th colSpan={headers.length} data-testid="selected-header">
          <Heading variant="h5">
            {t("selectHeader.selected", {number: selected.length})}
          </Heading>
        </th>
      ) : (
        headers.map((header, i) => (
          <th key={i} data-testid="select-header">
            {typeof header === "string"
              ?  <Heading variant="h5">{header}</Heading>
              : header
            }
          </th>
        ))
      )}
    </tr>
  )
}

